import axios from '../axios-auth'
import orginal_axios from "axios";

export const outstandingInvoiceReportService = {
    getOutstandingInvoiceReport,
    getAllOutstandingInvoiceReport,
    getOutstandingInvoiceReportExcelExport,
    getOutstandingInvoiceReportByCategoryGroup,
    getOutstandingInvoiceReportByCategoryGroupPrint
}

function getOutstandingInvoiceReport(searchParams, page, size, sortedBy) {
    if (!page) {
        page = 0;
    }
    else {
        page -= 1;
    }
    if (!size) {
        size = 50;
    }

    let params = {
        page: page,
        size: size,
        sort: sortedBy
    };

    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }
    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }
    if (searchParams.customerIds) {
        params["customerIds"] = searchParams.customerIds.join();
    }
    if (searchParams.invoiceNo) {
        params["invoiceNo"] = searchParams.invoiceNo;
    }
    if (searchParams.shopId) {
        params["shopId"] = searchParams.shopId;
    }
    if (searchParams.wholeSaleStatus) {
        params["wholeSaleStatus"] = searchParams.wholeSaleStatus;
    }
    if (searchParams.cityIds) {
        params["cityIds"] = searchParams.cityIds.join();
    }
    if (searchParams.updateUserId) {
        params["updateUserId"] = searchParams.updateUserId;
    }
    if (searchParams.description) {
        params["description"] = searchParams.description;
    }

    return axios.get("/auth/outstanding-invoice-report", { params });
}

function getAllOutstandingInvoiceReport(searchParams) {
    let params = {};

    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }
    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }
    if (searchParams.customerIds) {
        params["customerIds"] = searchParams.customerIds.join();
    }
    if (searchParams.invoiceNo) {
        params["invoiceNo"] = searchParams.invoiceNo;
    }
    if (searchParams.shopId) {
        params["shopId"] = searchParams.shopId;
    }
    if (searchParams.wholeSaleStatus) {
        params["wholeSaleStatus"] = searchParams.wholeSaleStatus;
    }
    if (searchParams.cityIds) {
        params["cityIds"] = searchParams.cityIds.join();
    }
    if (searchParams.updateUserId) {
        params["updateUserId"] = searchParams.updateUserId;
    }
    if (searchParams.description) {
        params["description"] = searchParams.description;
    }

    return axios.get("/auth/outstanding-invoice-report-print", { params });
}

function getOutstandingInvoiceReportExcelExport(searchParams) {
    let params = {};

    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }
    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }
    if (searchParams.customerIds) {
        params["customerIds"] = searchParams.customerIds.join();
    }
    if (searchParams.invoiceNo) {
        params["invoiceNo"] = searchParams.invoiceNo;
    }
    if (searchParams.shopId) {
        params["shopId"] = searchParams.shopId;
    }
    if (searchParams.wholeSaleStatus) {
        params["wholeSaleStatus"] = searchParams.wholeSaleStatus;
    }
    if (searchParams.cityIds) {
        params["cityIds"] = searchParams.cityIds.join();
    }
    if (searchParams.updateUserId) {
        params["updateUserId"] = searchParams.updateUserId;
    }
    if (searchParams.description) {
        params["description"] = searchParams.description;
    }
    return orginal_axios({
        method: "GET",
        url: axios.defaults.baseURL + "/auth/outstanding-invoice-report-excel",
        params,
        responseType: "arraybuffer", // important
        headers: {
            Authorization: "Bearer " + localStorage.getItem("accessToken"),
            Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        }
    }).then(function (response) {
        return { blob: new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }), headers: response.headers }
    });
}

function getOutstandingInvoiceReportByCategoryGroup(searchParams, page, size, sortedBy) {
    if (!page) {
        page = 0;
    }
    else {
        page -= 1;
    }
    if (!size) {
        size = 50;
    }

    let params = {
        page: page,
        size: size,
        sort: sortedBy
    };

    if (searchParams.shopId) {
        params["shopId"] = searchParams.shopId;
    }
    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }
    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }
    if (searchParams.customerIds) {
        params["customerIds"] = searchParams.customerIds.join();
    }
    if (searchParams.cityIds) {
        params["cityIds"] = searchParams.cityIds.join();
    }
    if (searchParams.wholeSaleStatus) {
        params["wholeSaleStatus"] = searchParams.wholeSaleStatus;
    }
    if (searchParams.categoryGroupId) {
        params["categoryGroupId"] = searchParams.categoryGroupId;
    }

    return axios.get("/auth/outstanding-invoice-report-by-category-group", { params });
}

function getOutstandingInvoiceReportByCategoryGroupPrint(searchParams) {
    let params = {};

    if (searchParams.shopId) {
        params["shopId"] = searchParams.shopId;
    }
    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }
    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }
    if (searchParams.customerIds) {
        params["customerIds"] = searchParams.customerIds.join();
    }
    if (searchParams.cityIds) {
        params["cityIds"] = searchParams.cityIds.join();
    }
    if (searchParams.wholeSaleStatus) {
        params["wholeSaleStatus"] = searchParams.wholeSaleStatus;
    }
    if (searchParams.categoryGroupId) {
        params["categoryGroupId"] = searchParams.categoryGroupId;
    }

    return axios.get("/auth/outstanding-invoice-report-by-category-group-print", { params });
}